const REACT_APP_BACKEND_API = process.env.REACT_APP_BACKEND_API || 'https://microservices.dev.ole-sp.com.mx/api-client/';
const REACT_APP_BACKEND_DIGITAL_SIGNATURE = process.env.REACT_APP_BACKEND_DIGITAL_SIGNATURE || 'https://microservices.dev.ole-sp.com.mx/ole-api-digital-signature/';
const REACT_APP_SIGNATURE_CALLBACK = process.env.REACT_APP_SIGNATURE_CALLBACK || 'https://microservices.dev.ole-sp.com.mx/api-client/application/sign/webhook-callback/MX/';
const REACT_APP_BUCKET_DIGITAL_SIGNATURE = process.env.REACT_APP_BUCKET_DIGITAL_SIGNATURE || 'files-application'
const REACT_APP_API_OTP = process.env.REACT_APP_API_OTP || 'https://quote-api-dev-vq7udsfd6q-ue.a.run.app/api/message/otp/';
const REACT_APP_API_PAYMENT = process.env.REACT_APP_API_PAYMENT || 'https://microservices.dev.ole-sp.com.mx/api-payments/v1/';
const REACT_APP_API_QUOTATION = process.env.REACT_APP_API_QUOTATION || 'https://microservices.dev.ole-sp.com.mx/api-quotation/v1/quotations/';
const REACT_APP_API_KEY_QUOTATION_BR = process.env.REACT_APP_API_KEY_QUOTATION_BR || 'admin-mx';
const REACT_APP_API_KEY_QUOTATION_INT = process.env.REACT_APP_API_KEY_QUOTATION_INT || 'admin';
const REACT_APP_QUOTATION_API_KEY = process.env.REACT_APP_QUOTATION_API_KEY || 'admin';
const REACT_APP_API_CLIENT_KEY = process.env.REACT_APP_API_CLIENT_KEY || 'admin';
const REACT_APP_SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';
const REACT_APP_AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY || '';
const REACT_APP_CLOUD_FRONT_FILES = process.env.REACT_APP_CLOUD_FRONT_FILES || 'https://dliwgla2kjv71.cloudfront.net/MX/legal-documents/';
const REACT_APP_COUNTRY = process.env.REACT_APP_COUNTRY || 'MX';
const REACT_APP_SIGNATURE_TIME2SAVE = process.env.REACT_APP_SIGNATURE_TIME2SAVE || 3650;
const REACT_APP_SIGNATURE_TIME2CLOSE = process.env.REACT_APP_SIGNATURE_TIME2CLOSE || 10;
const REACT_APP_SIGNATURE_BILLING_COST = process.env.REACT_APP_SIGNATURE_BILLING_COST || '0';
const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'development';
const REACT_APP_URL_LOGALTY_SIGNATURE = process.env.REACT_APP_URL_LOGALTY_SIGNATURE || 'https://www.demo.logalty.es/lgt/lgtfrontend/login/samlLogin';
const REACT_APP_GTM_ID = process.env.REACT_APP_GTM_ID || 'GTM-PLACEHOLDER';
const REACT_APP_PAYMENT_WEB_URL = process.env.REACT_APP_PAYMENT_WEB_URL || 'https://payments.dev.olelife.com.br/';
const REACT_APP_QUOTE_VERSION_BR = process.env.REACT_APP_QUOTE_VERSION_BR || 'v2';
const REACT_APP_API_ADVISOR_PORTAL = process.env.REACT_APP_API_ADVISOR_PORTAL || 'https://microservices.stg.olelife.com.br/api-advisor-portal/v1/';
const REACT_APP_API_ADVISOR_PORTAL_KEY = process.env.REACT_APP_API_ADVISOR_PORTAL_KEY || 'd8b3a8a9-f66f-4c2c-9231-d1b0a257edf4';
/** W5a: schema-driven intake path for this market build (`on` | `off`). Default off until W5b. */
const REACT_APP_INTAKE_SCHEMA_PATH = process.env.REACT_APP_INTAKE_SCHEMA_PATH || 'off';
/** Chatbot (CHATBOT.md Paso 3): enables `?channel=chat` for this market build (`on` | `off`). */
const REACT_APP_INTAKE_CHAT = process.env.REACT_APP_INTAKE_CHAT || 'off';
/** Base URL of ole-api-conversation (no trailing slash needed). */
const REACT_APP_CONVERSATION_API = process.env.REACT_APP_CONVERSATION_API || 'http://localhost:8090';
/**
 * Site key de Cloudflare Turnstile para abrir el chat (ole-api-conversation lo verifica al crear la
 * sesión). Vacía = sin desafío: así funciona hasta que el servicio prenda `TURNSTILE_SECRET`.
 */
const REACT_APP_TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';
/**
 * CTA al Client Portal en `/congratulations`. Interruptor único y explícito:
 * el botón aparece SOLO si esta variable vale 'true'. Fail-closed de verdad —
 * si no está definida, o dice cualquier otra cosa, no hay botón.
 *
 * A propósito NO se deriva de REACT_APP_ENVIRONMENT ni de NODE_ENV: la primera
 * la comparten Sentry/Amplitude y su valor en dev-AWS sale de un parámetro SSM
 * que este repo no controla; la segunda no distingue Railway de dev-AWS (los
 * dos compilan con `react-scripts build`). Se prende a mano donde se quiera:
 * Railway, y el `.env.local` de cada máquina.
 */
const REACT_APP_CLIENT_PORTAL_CTA = process.env.REACT_APP_CLIENT_PORTAL_CTA || '';
/**
 * Local development only: when `on`, test quotes in the INTAKE flow upload files instead
 * of writing stub paths, so the S3 path can be exercised against a local S3
 * (`docs/local-development.md`). Unset/`off` keeps the deployed behaviour — test quotes
 * never touch S3. The legacy wizard is out of scope: its `isTest` guards stay as-is.
 */
const REACT_APP_LOCAL_FILE_UPLOADS = process.env.REACT_APP_LOCAL_FILE_UPLOADS || 'off';
/**
 * Herramientas de desarrollo del intake (flotante de carga de datos).
 *
 * Interruptor único y explícito, fail-closed: la variable tiene que EXISTIR y
 * valer 'true'. Sin definir, o con cualquier otro valor, no hay flotante y su
 * código no se descarga (va detrás de un `React.lazy`).
 *
 * A propósito NO se deriva de NODE_ENV ni de REACT_APP_ENVIRONMENT, por el
 * mismo motivo que REACT_APP_CLIENT_PORTAL_CTA: los seis pipelines compilan con
 * `react-scripts build` (NODE_ENV = production también en dev-mx), y
 * REACT_APP_ENVIRONMENT la comparten Sentry y Amplitude, con su valor en
 * dev-AWS saliendo de un parámetro SSM que este repo no controla.
 *
 * Dónde se prende: `.env.local` o `.env.development` en local, variables del
 * servicio en Railway, y el parámetro SSM del mercado para dev/stg de AWS
 * (`/web-application-mx` cubre dev-mx y stg-mx a la vez). En el parámetro de
 * producción (`/web-application`) no se agrega.
 */
const REACT_APP_INTAKE_DEVTOOLS = process.env.REACT_APP_INTAKE_DEVTOOLS || '';

export {
    REACT_APP_BACKEND_API,
    REACT_APP_BACKEND_DIGITAL_SIGNATURE,
    REACT_APP_BUCKET_DIGITAL_SIGNATURE,
    REACT_APP_API_OTP,
    REACT_APP_API_PAYMENT,
    REACT_APP_API_QUOTATION,
    REACT_APP_API_KEY_QUOTATION_BR,
    REACT_APP_API_KEY_QUOTATION_INT,
    REACT_APP_QUOTATION_API_KEY,
    REACT_APP_API_CLIENT_KEY,
    REACT_APP_SENTRY_DSN,
    REACT_APP_AMPLITUDE_API_KEY,
    REACT_APP_SIGNATURE_CALLBACK,
    REACT_APP_CLOUD_FRONT_FILES,
    REACT_APP_COUNTRY,
    REACT_APP_SIGNATURE_TIME2SAVE,
    REACT_APP_SIGNATURE_TIME2CLOSE,
    REACT_APP_SIGNATURE_BILLING_COST,
    REACT_APP_ENVIRONMENT,
    REACT_APP_URL_LOGALTY_SIGNATURE,
    REACT_APP_GTM_ID,
    REACT_APP_PAYMENT_WEB_URL,
    REACT_APP_QUOTE_VERSION_BR,
    REACT_APP_API_ADVISOR_PORTAL,
    REACT_APP_API_ADVISOR_PORTAL_KEY,
    REACT_APP_INTAKE_SCHEMA_PATH,
    REACT_APP_INTAKE_CHAT,
    REACT_APP_CONVERSATION_API,
    REACT_APP_TURNSTILE_SITE_KEY,
    REACT_APP_CLIENT_PORTAL_CTA,
    REACT_APP_LOCAL_FILE_UPLOADS,
    REACT_APP_INTAKE_DEVTOOLS
};